(function () {
  "use strict";

  if (window.__SOWN_GA4_LOADED__) return;
  window.__SOWN_GA4_LOADED__ = true;

  var previousCart = null;
  var viewedLists = {};

  function hasGtag() {
    return typeof window.gtag === "function";
  }

  function track(eventName, params) {
    if (!hasGtag()) return;
    window.gtag("event", eventName, Object.assign({ transport_type: "beacon" }, params || {}));
  }

  function moneyToNumber(value) {
    return Math.round(Number(value || 0)) / 100;
  }

  function normalizeLineItem(item, quantityOverride) {
    return {
      item_id: item.sku || String(item.variant_id || item.id || ""),
      item_name: item.product_title || item.title || "",
      item_variant: item.variant_title || "",
      item_brand: item.vendor || "Sown Beauty",
      product_handle: item.handle || "",
      selected_variant_id: String(item.variant_id || item.id || ""),
      price: moneyToNumber(item.final_price || item.price),
      quantity: typeof quantityOverride === "number" ? quantityOverride : Number(item.quantity || 1)
    };
  }

  function cartValue(cart) {
    return moneyToNumber(cart && cart.total_price);
  }

  function fetchCart() {
    return fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "/") + "cart.js", {
      credentials: "same-origin"
    }).then(function (response) {
      return response.json();
    });
  }

  function findPreviousLine(item) {
    if (!previousCart || !previousCart.items) return null;
    for (var i = 0; i < previousCart.items.length; i++) {
      var previous = previousCart.items[i];
      if (previous.key && item.key && previous.key === item.key) return previous;
      if (String(previous.variant_id) === String(item.variant_id)) return previous;
    }
    return null;
  }

  function trackRemovedItems(newCart, source) {
    if (!previousCart || !previousCart.items || !newCart || !newCart.items) return;
    var newByKey = {};
    newCart.items.forEach(function (item) {
      newByKey[item.key || item.variant_id] = item;
    });

    previousCart.items.forEach(function (oldItem) {
      var key = oldItem.key || oldItem.variant_id;
      var newItem = newByKey[key];
      var oldQty = Number(oldItem.quantity || 0);
      var newQty = newItem ? Number(newItem.quantity || 0) : 0;
      if (newQty >= oldQty) return;
      var removedQty = oldQty - newQty;
      track("remove_from_cart", {
        currency: "USD",
        value: moneyToNumber((oldItem.final_price || oldItem.price) * removedQty),
        cart_action_source: source || "cart",
        items: [normalizeLineItem(oldItem, removedQty)]
      });
    });
  }

  function trackViewCart(source) {
    fetchCart().then(function (cart) {
      previousCart = cart;
      track("view_cart", {
        currency: "USD",
        value: cartValue(cart),
        cart_action_source: source || "cart",
        items: (cart.items || []).map(function (item) {
          return normalizeLineItem(item);
        })
      });
    }).catch(function () {});
  }

  function getProductCard(anchor) {
    return anchor.closest(".product-card-wrapper, .card-wrapper, .grid__item, .collection-list__item");
  }

  function getProductHandle(anchor) {
    try {
      var url = new URL(anchor.href, window.location.href);
      var match = url.pathname.match(/\/products\/([^/?#]+)/);
      return match ? match[1] : "";
    } catch (e) {
      return "";
    }
  }

  function getItemListName(anchor) {
    var section = anchor.closest("[id^='shopify-section-']");
    if (!section) return document.body.className.indexOf("template-search") !== -1 ? "search_results" : "site_product_list";
    return section.id.replace(/^shopify-section-/, "");
  }

  function trackSelectItem(anchor) {
    var handle = getProductHandle(anchor);
    if (!handle) return;
    var itemListName = getItemListName(anchor);
    track("select_item", {
      item_list_name: itemListName,
      product_handle: handle,
      items: [{
        item_id: handle,
        item_name: (anchor.textContent || "").replace(/\s+/g, " ").trim(),
        item_brand: "Sown Beauty",
        product_handle: handle,
        item_list_name: itemListName
      }]
    });
  }

  function trackVisibleProductLists() {
    var cards = Array.prototype.slice.call(document.querySelectorAll(".product-card-wrapper a[href*='/products/'], .card-wrapper a[href*='/products/']"));
    var lists = {};
    cards.forEach(function (anchor) {
      var card = getProductCard(anchor);
      if (!card) return;
      var listName = getItemListName(anchor);
      var handle = getProductHandle(anchor);
      if (!handle) return;
      if (!lists[listName]) lists[listName] = [];
      if (lists[listName].length >= 20) return;
      lists[listName].push({
        item_id: handle,
        item_name: (anchor.textContent || "").replace(/\s+/g, " ").trim(),
        item_brand: "Sown Beauty",
        product_handle: handle,
        item_list_name: listName
      });
    });

    Object.keys(lists).forEach(function (listName) {
      if (viewedLists[listName]) return;
      viewedLists[listName] = true;
      track("view_item_list", {
        item_list_name: listName,
        items: lists[listName]
      });
    });
  }

  function trackTheLashListLanding() {
    var params = new URLSearchParams(window.location.search);
    var source = (params.get("utm_source") || "").toLowerCase();
    var clickId = params.get("tll_click_id") || "";
    if (source !== "thelashlist" && !clickId) return;

    try {
      if (clickId) window.sessionStorage.setItem("sown_tll_click_id", clickId);
      window.sessionStorage.setItem("sown_landing_partner", "thelashlist");
    } catch (e) {}

    track("tll_landing", {
      landing_source_site: "thelashlist.com",
      landing_partner: "thelashlist",
      tll_campaign_slug: params.get("utm_campaign") || "",
      tll_cta_position: params.get("utm_content") || "",
      tll_click_id: clickId
    });
  }

  function bindCartEvents() {
    if (typeof PUB_SUB_EVENTS !== "undefined" && typeof subscribe === "function") {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        var source = event && event.source ? event.source : "cart";
        if (event && event.cartData && event.cartData.items) {
          trackRemovedItems(event.cartData, source);
          previousCart = event.cartData;
        } else {
          fetchCart().then(function (cart) {
            trackRemovedItems(cart, source);
            previousCart = cart;
          }).catch(function () {});
        }
      });
    }

    document.addEventListener("click", function (event) {
      var cartLink = event.target.closest && event.target.closest("#cart-icon-bubble, a[href='/cart'], a[href$='/cart']");
      if (cartLink) trackViewCart("cart_open");

      var checkout = event.target.closest && event.target.closest("button[name='checkout'], #checkout, .cart__checkout-button, a[href*='/checkout']");
      if (checkout) {
        fetchCart().then(function (cart) {
          track("checkout_click", {
            currency: "USD",
            value: cartValue(cart),
            checkout_source: checkout.closest("cart-drawer") ? "cart_drawer" : "cart_page",
            items: (cart.items || []).map(function (item) {
              return normalizeLineItem(item);
            })
          });
        }).catch(function () {});
      }

      var productAnchor = event.target.closest && event.target.closest("a[href*='/products/']");
      if (productAnchor && getProductCard(productAnchor)) trackSelectItem(productAnchor);
    }, true);
  }

  function bindLeadForms() {
    document.addEventListener("submit", function (event) {
      var form = event.target;
      if (!form || !form.querySelector) return;
      var emailInput = form.querySelector('input[type="email"], input[name*="email" i]');
      if (!emailInput) return;
      var location = form.closest("footer") ? "footer" : form.closest(".newsletter") ? "newsletter_section" : "site_form";
      track("newsletter_signup", {
        event_category: "lead",
        form_location: location
      });
    }, true);
  }

  function init() {
    fetchCart().then(function (cart) {
      previousCart = cart;
    }).catch(function () {});
    trackTheLashListLanding();
    trackVisibleProductLists();
    bindCartEvents();
    bindLeadForms();
    if (window.location.pathname === "/cart") trackViewCart("cart_page");
  }

  window.SownAnalytics = {
    track: track,
    trackViewCart: trackViewCart
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
